import { getBlockerStyle } from '@bingads-webui-campaign-react/common-styles';


const IMAGE_DIM = {
  width: 106,
  height: 76,
  marginRight: 8,
};

const PaddleBottomValue = 18;

export const getCarouselStyles = (components, { palette = {} } = {}, iconFontFamily = 'MsAds MDL2 Assets') => ({
  carouselParent: {
    position: 'relative',
    display: 'inline-flex',
    width: '100%',
    alignItems: 'end',
  },
  disabledCarouselParent: {
    pointerEvents: 'none',
    opacity: 0.4,
  },
  image: {
    ...IMAGE_DIM,
    boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)',
    objectFit: 'cover',
    borderRadius: 6,
  },
  imageContainer: ({ imageContainerLeftMargin, isCollapsible }) => ({
    height: IMAGE_DIM.height,
    overflowX: 'hidden',
    overflowY: 'hidden',
    display: 'inline-block',
    marginLeft: isCollapsible ? imageContainerLeftMargin : 0,
    flexGrow: 1,
  }),
  imageParentContainer: ({ imageParentLeftOffset, numberOfImages }) => ({
    width: (IMAGE_DIM.width + IMAGE_DIM.marginRight) * numberOfImages,
    position: 'relative',
    left: ((-1 * IMAGE_DIM.width) - IMAGE_DIM.marginRight) * imageParentLeftOffset,
  }),
  imageClickableContainer: {
    display: 'inline',
    '& :hover': {
      cursor: 'pointer',
    },
  },
  loadingMessageContainer: {
    marginTop: 16,
    marginLeft: 16,
  },
  loadingText: {
    display: 'inline-block',
    fontSize: '12px',
    lineHeight: '16px',
    verticalAlign: 'top',
  },
  panel: {},
  panelHeading: {
    display: 'flex',
    '& :hover': {
      backgroundColor: palette.neutralLighterAlt,
    },
  },
  panelTitle: {
    flexGrow: 1,
  },
  panelIcon: {
    marginRight: 3,
    paddingBottom: 12,
    '&:before': {
      fontFamily: iconFontFamily,
      content: '"\\E3AF"',
    },
  },
  panelHelpButton: {
    display: 'inline-block',
  },
  imageHintRight: {
    display: 'inline-block',
    position: 'absolute',
    background: 'linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0.927755) 18.23%, rgba(255, 255, 255, 0.776042) 48.44%, rgba(250, 249, 255, 0.5) 78.24%, rgba(255, 255, 255, 0) 100%)',
    width: 20,
    height: IMAGE_DIM.height,
    right: 32,
  },
  imageHintLeft: {
    display: 'inline-block',
    position: 'absolute',
    background: 'linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0.927755) 18.23%, rgba(255, 255, 255, 0.776042) 48.44%, rgba(250, 249, 255, 0.5) 78.24%, rgba(255, 255, 255, 0) 100%)',
    width: 30,
    height: IMAGE_DIM.height,
    left: 34,
    transform: 'rotate(-180deg)',
  },
  paddleBtn: {
    bottom: PaddleBottomValue,
  },
  paddleBtnRight: {
    bottom: PaddleBottomValue,
  },
  moreIcon: {
    fontSize: '18px',
    height: '60px',
    width: '33px',
    color: palette.themeDarkAlt,
  },
  seeAll: {
    display: 'inline-block',
    position: 'absolute',
    right: 0,
    bottom: 12,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  seeAllInHeader: {
    display: 'flex',
    alignItems: 'center',
    '& a': {
      position: 'static',
      color: palette.themePrimary,
      fontSize: 14,
      '&:hover, $:acitve, $:focus': {
        color: palette.themeDarkAlt,
      },
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
  },
  spinner: {
    ...(components.getBlockerStyle ? components.getBlockerStyle(16, palette) : {}),
    display: 'inline-block',
    lineHeight: '16px',
  },
  parentContainer: {
    '& $panel': { // need more selector specificity to override styles applied to top of grid panels
      marginLeft: 0,
      marginTop: 12,
    },
    '& $panelHeading': {
      border: 'none',
      '& $panelTitle.collapsible-title': {
        fontSize: '12px',
        fontWeight: 600,
        lineHeight: '24px',
        '& > a': {
          '& .helpbutton': {
            fontSize: '14px',
            lineHeight: '24px',
            display: 'inline',
            verticalAlign: 'bottom',
          },
        },
        marginTop: 0,
      },
    },
    '& + .alert-info': {
      marginTop: 8,
      '& a': {
        color: palette.themeDarkAlt,
      },
    },
  },
});

export const getStyles = (components, { palette = {} } = {}) => ({
  '@global': {
    '@keyframes loading_placeholder': {
      '0%': { backgroundPosition: '87.5%' }, // The whole background is 800% and we use only the 0-7 range
      '100%': { backgroundPosition: '0%' },
    },
  },
  imageSuggestionCarousel: {
    marginTop: '18px',
    '& .blocker-image': {
      ...getBlockerStyle(28, palette),
      display: 'inline-block',
    },
    '& .title': {
      '& span': {
        fontWeight: 600,
      },
      marginBottom: '14px',
    },
    '& .message-bar': {
      marginTop: '8px',
    },
    '& .add-image-banner': {
      display: 'flex',
      overflow: 'hidden',
      '& .loading-carousel': {
        width: '320px',
        display: 'block',
        height: '76px',
        '& .loading-carousel-inner': {
          display: 'inline-flex',
          width: '100%',
          position: 'relative',
          alignItems: 'end',
          '& .loading-carousel-blocks-parent': {
            display: 'inline-block',
            width: '100%',
            height: '76px',
            flexGrow: 1,
            overflow: 'hidden',
            '& .loading-carousel-blocks': {
              width: '1596px',
              '& .loading-cell': {
                width: '106px',
                height: '76px',
                borderRadius: '6px',
                backgroundSize: '800%',
                background: 'linear-gradient(to right, #EDEBE9 0%, #EDEBE9 12.5%, #F3F2F1 25%, #F3F2F1 87.5%, #EDEBE9 100%)',
                animation: 'loading_placeholder 3s linear infinite',
                marginRight: '8px',
                display: 'inline-block',
              },
            },
          },
          '& .loading-carousel-hint': {
            right: '0px',
            top: '0px',
            width: '20px',
            height: '76px',
            display: 'inline-block',
            position: 'absolute',
            background: 'linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0.927755) 18.23%, rgba(255, 255, 255, 0.776042) 48.44%, rgba(250, 249, 255, 0.5) 78.24%, rgba(255, 255, 255, 0) 100%)',
          },
        },
      },
      '& .add-image-button': {
        width: 'unset',
        height: 'unset',
        padding: '0px',
        marginRight: '8px',
        '& span': {
          width: '106px',
          height: '76px',
          borderRadius: '6px',
          border: `1px dashed ${palette.neutralTertiaryAlt}`,
        },
      },
      '& > .image-suggestion-carousel-root': {
        width: '302px',
        '& > .panel': {
          marginTop: 'unset',
          marginBottom: 'unset',
        },
      },
    },
  },
});
